import { motion } from 'framer-motion';

const HOLLYWOOD_IMG = 'https://images.pexels.com/photos/2695679/pexels-photo-2695679.jpeg';

const Gallery = () => {
  const images = [
    { src: 'https://images.pexels.com/photos/804115/pexels-photo-804115.jpeg', alt: 'Santa Monica Pier sunset California coastline' },
    { src: HOLLYWOOD_IMG, alt: 'Hollywood Sign Los Angeles hillside California' },
    { src: 'https://static.prod-images.emergentagent.com/jobs/e17238f4-6670-41c0-9f2d-00e20837d10a/images/fafec82a2924312616767d0f5acaab7508ef26c05908f15f5030b099cbc74c79.png', alt: 'Rodeo Drive Beverly Hills luxury shopping district' },
    { src: 'https://images.pexels.com/photos/4700359/pexels-photo-4700359.jpeg', alt: 'Hollywood Walk of Fame stars at night' },
    { src: 'https://images.unsplash.com/photo-1599565508598-50662247a557', alt: 'Beverly Hills luxury mansion with tall palm trees' },
    { src: 'https://images.pexels.com/photos/36148684/pexels-photo-36148684.jpeg', alt: 'Warner Bros Studios water tower at sunset in Burbank' },
  ];

  return (
    <section className="section-padding bg-[#FDFBF7]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="font-caveat text-xl sm:text-2xl text-[#FF007A] mb-2">Preview Your Adventure</p>
          <h2 className="font-bebas text-4xl sm:text-5xl lg:text-6xl tracking-tighter uppercase">
            Captured Moments
          </h2>
          <p className="font-outfit text-base sm:text-lg text-[#4A4A4A] max-w-xl mx-auto mt-3">
            From the California coastline to the glamour of Beverly Hills — here is what awaits you.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
          {images.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className={`img-zoom rounded-xl overflow-hidden border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] ${
                i === 0 || i === 5 ? 'md:row-span-2 h-48 sm:h-60 md:h-full' : 'h-48 sm:h-60'
              }`}
              data-testid={`gallery-img-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
